import sanitizeFilename from 'sanitize-filename';

export const safeFilename = function safeFilename(filename: string): string {
  const removedSpaces = filename.replace(/\s|,/g, '_');
  return sanitizeFilename(removedSpaces).substring(0, 255);
};
